<template>
    <b-form-group :label="label">
        <c-switch
            color="success"
            variant="pill"
            label
            v-bind="{
                dataOn: $t('form.switch.yes'),
                dataOff: $t('form.switch.no'),
            }"
            :disabled="disabled"
            v-model="data"
        />
    </b-form-group>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'

export default {
    name: 'OnlyFocalPoint',
    components: {
        cSwitch,
    },
    props: ['value', 'disabled', 'label'],
    computed: {
        data: {
            get: function() {
                return this.value
            },
            set: function(value) {
                this.$emit('update:value', value)
            },
        },
    },
    watch: {
        disabled() {
            this.$emit('update:value', false)
        },
    },
}
</script>
